export function parseCSV(csv) {
    if (!csv || typeof csv !== "string") {
        return { headers: [], data: [] };
    }

    const lines = csv
        .split(/\r?\n/)
        .map(l => l.trim())
        .filter(l => l !== "");

    if (lines.length === 0) {
        return { headers: [], data: [] };
    }

    const delimiter = lines[0].includes(";") ? ";" : ",";

    const headers = lines[0]
        .split(delimiter)
        .map(h => h.trim());

    const data = lines.slice(1).map(line => {
        const values = line.split(delimiter);

        const row = {};
        headers.forEach((h, i) => {
            row[h] = (values[i] ?? "").trim();
        });

        row._isErrorRow = isErrorRow(row, headers);

        return row;
    });

    return { headers, data };
}

export function isErrorRow(row, headers) {
    const errorWords = ["ошибка", "не найдено", "missing", "error"];
    const skipWords = ["no error", "без ошибки"];

    const text = headers
        .map(h => String(row[h] || "").toLowerCase())
        .join(" ");

    // игнорировать "no error"
    if (skipWords.some(w => text.includes(w))) return false;

    // если встречается прямое слово ошибки
    return errorWords.some(w => text.includes(w));
}
